<template>
  <div class="cf-page-container">
    <div class="cf-card cf-card--mobile cf-flex cf-flex--column cf-flex--gap-16">
      <h1 class="cf-title cf-title--1">
        My Favorites
      </h1>

      <!-- Favorite Orders -->
      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <h2 class="cf-title cf-title--2">
          Favorite Orders
        </h2>

        <div
          v-if="favoriteOrders.areLoading"
          class="cf-section-loader-container"
        >
          <div class="cf-loader" />
        </div>

        <p
          v-else-if="favoriteOrders.orders.length === 0"
          class="cf-subtitle cf-subtitle--2"
        >
          You don't have any favorite orders. You can save a favorite order next time you checkout.
        </p>

        <template v-else>
          <cf-favorite-order
            v-for="order in favoriteOrders.orders"
            :key="order.orderId"
            :order="order"
          />
        </template>
      </div>

      <cf-title-separator :omit-title="true" />

      <!-- Favorite Items -->
      <div class="cf-flex cf-flex--column cf-flex--gap-16">
        <h2 class="cf-title cf-title--2">
          Favorite Items
        </h2>

        <div
          v-if="favoriteItems.areLoading"
          class="cf-section-loader-container"
        >
          <div class="cf-loader" />
        </div>

        <p
          v-else-if="favoriteItems.items.length === 0"
          class="cf-subtitle cf-subtitle--2"
        >
          You don't have any favorites items. You can save a favorite item on the menu or checkout page.
        </p>

        <div
          v-else
          class="cf-flex cf-flex--column cf-flex--gap-12"
        >
          <cf-menu-list-item
            v-for="item in favoriteItems.items"
            :key="item.originalFavoriteItemId"
            :item="item"
            :is-favorite="true"
            :show-item-rating="false"
            :is-menu-view="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfFavoriteOrder from './cf-favorite-order/index.vue';

  import CfTitleSeparator from '@/view/components/shared/cf-title-separator/index.vue';

  import CfMenuListItem from '@/view/components/globals/cf-menu-list/cf-menu-list-item/index.vue';


  export default {
    name: 'FavoriteOrdersPage',

    components: {
      CfFavoriteOrder,
      CfMenuListItem,
      CfTitleSeparator
    },

    metaInfo() {
      return {
        title: 'Favorites'
      };
    },

    data() {
      return {
        reorderingOrderId: null
      };
    },

    computed: {
      ...mapGetters('favoriteItems', ['favoriteItems']),
      ...mapGetters('favoriteOrders', ['favoriteOrders']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('menu', ['menu']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('session', ['orderDetails'])
    },

    created() {
      this.onComponentCreated();
    },

    methods: {
      onComponentCreated() {
        this.$store.dispatch('favoriteItems/getFavoriteItems');

        this.$store.dispatch('favoriteOrders/getFavoriteOrders');
      }
    }
  };
</script>
